export class SelectedDrugs {
  constructor(public readonly cbId: number,
              public readonly drugIds: number[],
              public readonly scenarioIds: number[]) {
  }
}
